/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_TitleInputs */

const en_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Format Events`)
};

const fr_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en Forme Automatique des Evenements`)
};

const de_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierungsereignisse`)
};

const it_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi di formattazione automatica`)
};

const ru_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование событий`)
};

const es_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de formato automático`)
};

const zh_cn2_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化事件`)
};

const ja_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの自動フォーマット`)
};

const hi_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित प्रारूप घटनाएँ`)
};

const pt_pt2_auto_format_title = /** @type {(inputs: Auto_Format_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática de eventos`)
};

/**
* | output |
* | --- |
* | "Auto Format Events" |
*
* @param {Auto_Format_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_title = /** @type {((inputs?: Auto_Format_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format_title(inputs)
	if (locale === "de") return de_auto_format_title(inputs)
	if (locale === "it") return it_auto_format_title(inputs)
	if (locale === "ru") return ru_auto_format_title(inputs)
	if (locale === "es") return es_auto_format_title(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format_title(inputs)
	if (locale === "ja") return ja_auto_format_title(inputs)
	if (locale === "hi") return hi_auto_format_title(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format_title(inputs)
	return en_auto_format_title(inputs)
});